import { render, staticRenderFns } from "./SimpleMessage.vue?vue&type=template&id=eeefe1ee&scoped=true&"
import script from "./SimpleMessage.vue?vue&type=script&lang=js&"
export * from "./SimpleMessage.vue?vue&type=script&lang=js&"
import style0 from "./SimpleMessage.vue?vue&type=style&index=0&id=eeefe1ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeefe1ee",
  null
  
)

export default component.exports